import { faCalendars } from '@fortawesome/pro-solid-svg-icons';

import { NavRoute } from '../../shared/navigation/nav.route.interface';

export const getMainNavMyAppointments: () => NavRoute = () => ({
	name: "My Appointments"
    // Admins see All Appointments instead
    , security: sec => sec.coreFeatures && !sec.adminFeatures
    , href: 'apts/list'
    , icon: faCalendars
    , area: 'apts'
    , expanded: globalThis.location.href.includes("/apts/")
    , children: getAreas()
});

function getAreas(): NavRoute[] {
    let id: string = "";
    let url = globalThis.location.href;

    if (url.includes('apts/view/')) { id = url.substring(url.lastIndexOf('/') + 1); }

    if (id === "") {
        return [
            {
                name: 'List'
                , exact: true
                , path: `apts/list`
                , activeNavLink: 'apts'
                , secondaryNav: [ 'My Appointments', 'List' ]
            }
        ];
    }

	return [
		{
			name: 'Back'
			, exact: true
			, path: `apts/list`
		}
        , {
			name: 'Details'
			, exact: true
			, path: `apts/view/${id}`
            , activeNavLink: 'apts'
            , secondaryNav: [ 'My Appointments', 'Details' ]
            
		}
	]
}